import { generateClasses } from '../../../utils/helper';

export const textFormattingButtonsClasses = generateClasses('TextFormattingButtons', [
  'toolbarButton',
  'bold',
  'italic',
  'underline',
  'toolbarIcon',
  'boldIcon',
  'italicIcon',
  'underlineIcon',
]);
